var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlertS = function SvgIconAlertS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z",
    fill: "#DD3955"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76 5.437 8.814 4H7.197l.054 1.437.23 3.814h1.05l.229-3.814ZM8.005 12a.973.973 0 0 0 .71-.28.978.978 0 0 0 .285-.712.944.944 0 0 0-.284-.703.955.955 0 0 0-.71-.29.955.955 0 0 0-.71.29.926.926 0 0 0-.296.703c0 .282.098.52.295.713.19.186.426.279.71.279Z",
    fill: "#fff"
  })));
};
export default SvgIconAlertS;